<template>
  <ul class="flex flex-wrap text-xs/[1.125rem] md:text-sm text-blue-50">
    <!-- eslint-disable vue/no-v-html -->
    <li
      v-for="(page, index) in pages"
      :key="index"
      class="flex items-center"
      :class="{
        'flex-1 truncate max-w-[15.75rem]': index === (pages.length - 1)
      }"
    >
      <nuxt-link
        v-if="!page.active && page.url"
        :to="page.url"
        class="flex items-center"
        :class="{
          'hover:underline': page.url,
          'hidden md:inline-block': maxItemDisplayed > 0 && index + 1 > maxItemDisplayed
        }"
      >
        {{ removeHtmlString(page.text) }}

        <IconsChevron
          type="default"
          size="lg"
          direction="right"
          fill="#8C9AAF"
          class="mx-1 w-4 h-4 p-[2px]"
        />
      </nuxt-link>

      <span
        v-else-if="!page.active && !page.url"
        class="flex items-center truncate w-full"
        :class="{
          'hover:underline': page.url,
          'hidden md:inline-block': maxItemDisplayed > 0 && index + 1 > maxItemDisplayed
        }"
      >
        {{ removeHtmlString(page.text) }}

        <IconsChevron
          type="default"
          size="lg"
          direction="right"
          fill="#8C9AAF"
          class="mx-1 w-4 h-4 p-[2px]"
        />
      </span>

      <span
        v-else
        class="font-bold text-dark align-middle w-full truncate"
        :class="[
          page.activeClass,
          {
            'hidden md:inline-block': maxItemDisplayed > 0 && index + 1 > maxItemDisplayed
          }
        ]"
        v-html="removeHtmlString(page.text)"
      >
      </span>
    </li>
  </ul>
</template>

<script setup>
import { arrayObjectPropValidator } from '~/helpers/validator'
import { CC_DOMAIN } from '~/helpers/constants'

defineOptions({
  name: 'AtomsBreadCrumb'
})

const props = defineProps({
  pages: {
    type: Array,
    default: () => [
      {
        text: 'Label',
        name: 'Name',
        url: '/',
        active: false
      }
    ],
    validator: value => {
      return arrayObjectPropValidator(value, ['text'])
    }
  },

  hasJsonSchema: {
    type: Boolean,
    default: false
  },

  maxItemDisplayed: {
    type: Number,
    default: 0
  }
})

useJsonld(() => {
  if (!props.hasJsonSchema) {
    return {}
  }

  const findActivePageIndex = props.pages.findIndex(page => page.active)
  const items = props.pages.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: `${CC_DOMAIN}${item.url}`,
    name: item?.text
  }))

  const breadcrumbId = findActivePageIndex >= 0
    ? `${CC_DOMAIN }${props.pages[findActivePageIndex].url}`
    : CC_DOMAIN

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': breadcrumbId + '#breadcrumb',
    itemListElement: items
  }
})
</script>
